import type { RefObject } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { useEffect } from 'react';

import type { EditorRefHandle } from '~/components';

import { forumTags, isAdminOnlyForumTag } from '~/api/forum/constants';
import { routes } from '~/providers/RouterProvider/router.routes';
import { removeFormDataFromSession, retrieveFormDataFromSession } from '~/utils/form';

import type { CreateForumPostForm } from './CreateForumPostDialog.types';

export const useForumPostPersistedFormValues = (form: UseFormReturn<CreateForumPostForm>, editorRef: RefObject<EditorRefHandle | null>) => {
  useEffect(() => {
    try {
      const persistedFormData = retrieveFormDataFromSession(routes.forum) as CreateForumPostForm | null;

      if (persistedFormData === null) return;

      if (form.getValues('tag') === null) {
        form.setValue('tag', forumTags.find((tag) => tag === persistedFormData.tag && !isAdminOnlyForumTag(tag)) ?? null);
      }

      form.setValue('title', persistedFormData.title);
      form.setValue('content', persistedFormData.content);

      editorRef.current?.setContent(persistedFormData.content);
    } finally {
      removeFormDataFromSession(routes.forum);
    }
  }, [editorRef, form]);
};
